export default {
  SET_RESTAURANTES_NEGOCIO(state, a) {
    state.restaurantesNegocio = a;
  },
};
